export enum AddressLevelType {
  Unknown="Unknown",
  Country="Country",
  City="City",
  Street="Street",
  House="House"
}
